// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2e-Xb","infoBtn":"quickbooks_infoBtn__1ZoQ2","formBox":"quickbooks_formBox__YOnTn","formFooter":"quickbooks_formFooter__1s-q5"};